export enum MyDevicesRoutesEnum {
  ROOT = "/menu/devices",
}

export enum MyDevicesPathsEnum {
  ROOT = "devices",
}
